import { GenIcon } from '../helpers/IconBase.es.js';

const RoundedTrashcanOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M13.9997 2.66667H11.933C11.7783 1.91428 11.3689 1.23823 10.7738 0.752479C10.1788 0.266727 9.43448 0.000969683 8.66634 0L7.33301 0C6.56487 0.000969683 5.82055 0.266727 5.22551 0.752479C4.63046 1.23823 4.22107 1.91428 4.06634 2.66667H1.99967C1.82286 2.66667 1.65329 2.7369 1.52827 2.86193C1.40325 2.98695 1.33301 3.15652 1.33301 3.33333C1.33301 3.51014 1.40325 3.67971 1.52827 3.80474C1.65329 3.92976 1.82286 4 1.99967 4H2.66634V12.6667C2.6674 13.5504 3.01893 14.3976 3.64382 15.0225C4.26871 15.6474 5.11594 15.9989 5.99967 16H9.99967C10.8834 15.9989 11.7306 15.6474 12.3555 15.0225C12.9804 14.3976 13.3319 13.5504 13.333 12.6667V4H13.9997C14.1765 4 14.3461 3.92976 14.4711 3.80474C14.5961 3.67971 14.6663 3.51014 14.6663 3.33333C14.6663 3.15652 14.5961 2.98695 14.4711 2.86193C14.3461 2.7369 14.1765 2.66667 13.9997 2.66667ZM7.33301 1.33333H8.66634C9.07986 1.33384 9.48309 1.46225 9.82075 1.70096C10.1584 1.93967 10.414 2.27699 10.5523 2.66667H5.44701C5.5854 2.27699 5.84094 1.93967 6.1786 1.70096C6.51626 1.46225 6.91949 1.33384 7.33301 1.33333ZM11.9997 12.6667C11.9997 13.1971 11.789 13.7058 11.4139 14.0809C11.0388 14.456 10.5301 14.6667 9.99967 14.6667H5.99967C5.46924 14.6667 4.96053 14.456 4.58546 14.0809C4.21039 13.7058 3.99967 13.1971 3.99967 12.6667V4H11.9997V12.6667Z",
          fill: "black",
          fillOpacity: "0.88"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.66667 11.9993C6.84348 11.9993 7.01304 11.9291 7.13807 11.8041C7.26309 11.6791 7.33333 11.5095 7.33333 11.3327V7.33268C7.33333 7.15587 7.26309 6.9863 7.13807 6.86128C7.01304 6.73625 6.84348 6.66602 6.66667 6.66602C6.48985 6.66602 6.32029 6.73625 6.19526 6.86128C6.07024 6.9863 6 7.15587 6 7.33268V11.3327C6 11.5095 6.07024 11.6791 6.19526 11.8041C6.32029 11.9291 6.48985 11.9993 6.66667 11.9993Z",
          fill: "black",
          fillOpacity: "0.88"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.33366 11.9993C9.51047 11.9993 9.68004 11.9291 9.80507 11.8041C9.93009 11.6791 10.0003 11.5095 10.0003 11.3327V7.33268C10.0003 7.15587 9.93009 6.9863 9.80507 6.86128C9.68004 6.73625 9.51047 6.66602 9.33366 6.66602C9.15685 6.66602 8.98728 6.73625 8.86226 6.86128C8.73723 6.9863 8.66699 7.15587 8.66699 7.33268V11.3327C8.66699 11.5095 8.73723 11.6791 8.86226 11.8041C8.98728 11.9291 9.15685 11.9993 9.33366 11.9993Z",
          fill: "black",
          fillOpacity: "0.88"
        }
      }
    ]
  })(props);
};

export { RoundedTrashcanOutlined };
